import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]

  connect() {
    this.toggle()
  }

  toggle() {
    const shouldShow = window.innerWidth < 1280 && window.scrollY > 160

    this.buttonTarget.classList.toggle("translate-y-5", !shouldShow)
    this.buttonTarget.classList.toggle("opacity-0", !shouldShow)
    this.buttonTarget.classList.toggle("pointer-events-none", !shouldShow)
    this.buttonTarget.setAttribute("aria-hidden", (!shouldShow).toString())
    this.buttonTarget.tabIndex = shouldShow ? 0 : -1
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }
}
